import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PHOTO_EDITED_STATUS } from 'domains/merchant-product/constants'

const propTypes = {
  photoEditedStatus: PropTypes.string.isRequired
}

/**
 * To give nice look on Merchant Product `photo_edited_status`.
 * It maps `photo_edited_status` to certain style and pass to `StatusBadge`.
 * @param {string} photographyStatus
 */
const MerchantProductPhotoEditedStatusBadge = ({ photoEditedStatus }) => {

  const colorMap = {
    [PHOTO_EDITED_STATUS.PENDING]   : 'warning',
    [PHOTO_EDITED_STATUS.COMPLETED] : 'success'
  }

  const color = colorMap[photoEditedStatus] || 'default'

  return <StatusBadge color={ color } label={ photoEditedStatus } />
}

MerchantProductPhotoEditedStatusBadge.propTypes = propTypes

export default MerchantProductPhotoEditedStatusBadge
